import { storeToRefs } from 'pinia'
import { useConfigStore } from '@/legacy/store/modules/config'
import { ReportIssueForm } from '@/legacy/types/reporting'
import { apiRequest } from '@/libs/api/api'

/**
 * Reports user-reported issue to Slack.
 * Returns null if config values are not set.
 * @param reportIssueForm
 */
export async function reportIssueToSlack(reportIssueForm: ReportIssueForm) {
  const { configVals } = storeToRefs(useConfigStore())

  if (!configVals.value || !configVals.value.apiUrl) {
    return null
  }
  return apiRequest('POST', '/api/reporting/thymebox_issue', {
    body: {
      route: reportIssueForm.route,
      issueType: reportIssueForm.issueType,
      fullUrl: reportIssueForm.fullUrl ?? '',
      description: reportIssueForm.description,
      reporter: reportIssueForm.reporter,
      reporterId: reportIssueForm.reporterId,
      uiVersion: reportIssueForm.uiVersion,
      canaryStatus: reportIssueForm.canaryStatus,
    },
  })
}
